import { render, staticRenderFns } from "./Ospendiente.vue?vue&type=template&id=63ab0496&scoped=true"
import script from "./Ospendiente.vue?vue&type=script&lang=js"
export * from "./Ospendiente.vue?vue&type=script&lang=js"
import style0 from "./Ospendiente.vue?vue&type=style&index=0&id=63ab0496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab0496",
  null
  
)

export default component.exports